// fill in both in order to get proper intellisense
export type BaseDict = {
    LiveStreamTooltip: string,
    FastMarketTooltip: string,
    StatisticTooltip: string,
    NoTodaysEvents: string,
    ServerError: string,
    FT_ML_1: string,
    FT_ML_2: string,
    FT_ML_3: string,

    FT_OU_1: string,
    FT_OU_2: string,
    FT_OU_3: string,

    FT_HC_1: string,
    FT_HC_2: string,
    FT_HC_3: string,

    DC_1: string,
    DC_2: string,
    DC_3: string,

    DNB_1: string,
    DNB_2: string,

    BTS_1: string,
    BTS_2: string,

    TG_1: string,
    TG_2: string,
    TG_3: string,

    G_1: string,
    G_2: string,
    G_3: string,

    // separate phrase for Full Time Over/Under for IceHockey;
    FT_OU_1_7: string

}
export const BaseDict: BaseDict = {
    LiveStreamTooltip: "Live Stream Available",
    FastMarketTooltip: "Fast Markets Available",
    StatisticTooltip: "Statistics",
    NoTodaysEvents: "no-todays-events",
    ServerError: "ServerError",
    FT_ML_1: "1",
    FT_ML_2: "X",
    FT_ML_3: "2",

    FT_OU_1: "Points",
    FT_OU_2: "Over",
    FT_OU_3: "Under",

    FT_HC_1: "",
    FT_HC_2: "",
    FT_HC_3: "",

    DC_1: "1X",
    DC_2: "X2",
    DC_3: "12",

    DNB_1: "1",
    DNB_2: "2",

    BTS_1: "Yes",
    BTS_2: "No",

    TG_1: "Goals",
    TG_2: "Over",
    TG_3: "Under",

    G_1: "Games",
    G_2: "Over",
    G_3: "Under",

    FT_OU_1_7: "Goals"
}